<template>
  <el-container direction='vertical'>
    <div class="head-container" :style="backgroundShop">
      <div class="masking"></div>
      <div class="shop-name">{{shopName}}</div>
      <!-- <div class="shop-name">香港富临皇宫</div> -->
      <div class="shop-vip" v-if="shopVip">黑金卡</div>
      <div class="shop-record">
        <span>充值次数：{{userInfo.rechargetimes}}次</span>
        <span>消费次数：{{userInfo.spendtimes}}次</span>
      </div>
    </div>
    <div class="user-container">
      <div class="head-img"><img :src="userInfo.wxheadurl" alt=""></div>
      <div v-if="userInfo.name!==''" class="head-name">{{userInfo.name}}</div>
      <div v-else class="head-name">{{userInfo.wxname}}</div>
      <div class="head-id">会员ID：<span>{{userInfo.mid}}</span></div>
    </div>
    <el-container>
      <ul class="option-container">
        <li @click="enterRechargeCenter">
          <div class="type-icon1"></div>
          <div class="connent">我的余额<span>{{userInfo.balance}}元</span></div>
          <template>
            <div v-if="parseFloat(userInfo.balance)>0" class="right-word"><span>充值</span></div>
            <div v-else class="right-word"><span>成为充值会员</span></div>
            <div class="right-icon"></div>
          </template>
        </li>
        <li @click="enterPayCenter">
          <div class="type-icon2"></div>
          <div class="connent">我要买单</div>
          <div class="right-word">买单</div>
          <div class="right-icon"></div>
        </li>
        <li @click="enterCouponList">
          <div class="type-icon3"></div>
          <div class="connent">优惠劵</div>
          <div class="right-word">有效券{{userInfo.couponcount}}张</div>
          <div class="right-icon"></div>
        </li>
        <li @click="enterCreditList" v-if="shopflag !== 'zhfh'">
          <div class="type-icon7"></div>
          <div class="connent">积分商城</div>
          <div class="right-word">{{credit}}分</div>
          <div class="right-icon"></div>
        </li>
        <li @click="enterBillList">
          <div class="type-icon4"></div>
          <div class="connent">账单</div>
          <div class="right-word">共充值{{userInfo.rechargeamount}}元，消费{{userInfo.spendamount}}元</div>
          <div class="right-icon"></div>
        </li>
        <li class="maggin-top" @click="enterPersonal">
          <div class="type-icon5"></div>
          <div class="connent">个人信息</div>
          <div v-if="userInfo.mobile === ''||userInfo.name ===''||userInfo.birthday===''" class="right-word">未完善</div>
          <div v-else class="right-word">修改</div>
          <!-- <div class="right-word"><a href="tel:18814133650">18814133650</a></div> -->
          <div class="right-icon"></div>
        </li>
        <li class="maggin-top" @click="enterAddress">
          <div class="type-icon6"></div>
          <div class="connent">门店及电话</div>
          <div class="right-icon"></div>
        </li>
      </ul>
    </el-container>
  </el-container>
</template>
<script>
import { getUserInfo, getAvailable } from '@/views/mobile/MemberCenter/apis'
const shopNameGroup = {
  gzahh: 'url(' + require('./assets/images/gzahh.png') + ')',
  gzwyh: 'url(' + require('./assets/images/gzwyh.jpg') + ')',
  zhfh: 'url(' + require('./assets/images/zhfh.jpg') + ')',
  hzhb: 'url(' + require('./assets/images/hzhb.jpg') + ')',
  fzth: 'url(' + require('./assets/images/fzth.jpg') + ')',
  szty: 'url(' + require('./assets/images/szty.jpg') + ')',
  test: 'url(' + require('./assets/images/fzth.jpg') + ')',
  test2: 'url(' + require('./assets/images/fzth.jpg') + ')'
}
export default {
  data () {
    return {
      userInfo: {},
      shopName: '',
      shopflag: '',
      shopVip: false,
      backgroundShop: {
        backgroundImage: '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      },
      credit: 0
    }
  },
  methods: {
    requestUserInfo () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.userInfo = result.data
            this.shopName = result.data.ext.shopname
            this.shopflag = result.data.ext.shopflag
            this.shopVip = result.data.ext.vip
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    getCredit () {
      getAvailable()
        .then(result => {
          if (result) {
            this.credit = result.data.points
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    enterRechargeCenter () {
      // if (this.shopflag === 'hzhb') {
      //   return
      // }
      // this.$router.push('/rechargeCenter')
      this.$router.push('/public/recharg')
    },
    enterPayCenter () {
      // this.$router.push('/payCenter')
      this.$router.push('/public/spend')
    },
    enterPersonal () {
      this.$router.push('/public/personal')
    },
    enterAddress () {
      this.$router.push('/public/address')
    },
    enterBillList () {
      this.$router.push('/billList')
    },
    enterCouponList () {
      this.$router.push('/couponList')
    },
    enterCreditList () {
      if (this.shopflag === 'zhfh') {
        return
      }
      this.$router.push('/goodsList')
    }
  },
  mounted () {
    this.requestUserInfo()
    this.getCredit()
  },
  created () {
    let shop = window.location.hostname.split('.')[0]
    this.backgroundShop.backgroundImage = shopNameGroup[shop]
  }
}
</script>
<style lang="less">
.nut-dialog-ok {
  background: linear-gradient(315deg, #fff 0%, #fff 100%);
}
.nut-dialog-ok:active {
  background: inherit;
}
@import "./assets/css/index.less";
</style>



// WEBPACK FOOTER //
// src/views/mobile/MemberCenter/index.vue